import React, { useEffect, useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import { DEFAULT_PRODUCTS_PAGE, DEFAULT_PRODUCTS_TAKE, setSearchQuery, useHandleSearch } from '../../store/features/searchSlice';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import ReactGA from 'react-ga4';


export interface SearchBarProps {
}

export const SearchBar: React.FC<SearchBarProps> = () => {
    const [searchText, setSearchText] = useState("");
    const dispatch = useAppDispatch();

    const searchQuery = useAppSelector((s) => s.search.searchQuery);
    const searchFromBtn = useAppSelector((s) => s.search.searchFromFilterBtn);
    const filters = useAppSelector((s) => s.search.filters);

    useEffect(() => {
        dispatch(setSearchQuery(searchText))
    }, [searchText]);

    useEffect(() => {
        setSearchText(searchQuery);
    }, [searchQuery]);

    const { handleSearch } = useHandleSearch();

    const handleSearchClick = () => {
        ReactGA.event({
            category: 'MainPage/SearchBar',
            action: 'Otsing sooritatud'
        });

        handleSearch({title: searchText, take: DEFAULT_PRODUCTS_TAKE, page: DEFAULT_PRODUCTS_PAGE}, searchFromBtn, true);
    }

    return (
        <div className="w-full h-[46px] rounded-xl flex flex-row align-middle p-2 bg-white shadow-main">


            <div className="h-[36px] w-[33px] flex items-center">
                <SearchIcon style={{ color: '#333' }} className="" />
            </div>


            <div className="flex w-full">
                <input
                    className="focus:outline-none w-[100%]"
                    type="text"
                    placeholder="Ma otsin..."
                    value={searchText} // Controlled value
                    onChange={(e) => setSearchText(e.target.value)} // Update state on input
                />
            </div>

            <button onClick={handleSearchClick} className="h-[34px] w-[70px] bg-primary rounded-xl text-white font-[600] tracking-wide">
                Otsi
            </button>

        </div>
    )
}